import { type CollectionConfig, CollectionLayout, CollectionSlug } from '../collections.types';

const IMAGES = 'https://p1.liveauctioneers.com/dist/images/fine-art-paintings';

export const paintingsCollection: CollectionConfig = {
    breadcrumbs: [
        { href: '/c/art/', label: 'Art' },
        { href: '', label: 'Paintings' },
    ],
    description:
        'From abstract and expressionist works to landscape, western and folk art paintings, discover original fine art from top auction houses worldwide.',
    itemNoun: 'paintings',
    layout: CollectionLayout.Collection,
    metaDescription:
        'Shop fine art paintings at auction — abstract, expressionist, landscape, western, folk art and British School works from top auction houses worldwide.',
    searchParams: { category_id: '10' },
    seoTitle: 'Fine Art Paintings for Sale at Auction',
    slug: CollectionSlug.Paintings,
    subcategories: [
        {
            href: '/c/paintings/style/abstract/?sale_type=liveAuction',
            imageUrl: `${IMAGES}-abstract-paintings.png`,
            title: 'Abstract Paintings',
        },
        {
            href: '/search/?keyword=western%20painting&status=online',
            imageUrl: `${IMAGES}-western-paintings.png`,
            title: 'Western Paintings',
        },
        {
            href: '/search/?category_id=10&keyword=impressionist%20landscape&sale_type=liveAuction&status=online',
            imageUrl: `${IMAGES}-landscape-paintings.png`,
            title: 'Landscape Paintings',
        },
        {
            href: '/search/?category_id=10&keyword=folk&status=online',
            imageUrl: `${IMAGES}-folk-art-paintings.png`,
            title: 'Folk Art Paintings',
        },
        {
            href: '/search/?category_id=10&keyword=expressionist&status=online',
            imageUrl: `${IMAGES}-expressionist-paintings.png`,
            title: 'Expressionist Paintings',
        },
        {
            href: '/search/?category_id=10&keyword=british&status=online',
            imageUrl: `${IMAGES}-british-school-paintings.png`,
            title: 'British School Paintings',
        },
    ],
    title: 'Fine Art Paintings',
};
